<template>
  <BaseChart
    height="335px"
    chart-height="200px"
    dark
    :class="{ 'with-title': !!chartData }"
    :chart-data="mergedChartData"
  >
    <template v-if="supportData" #header>
      <Grid>
        <Grid gaf="column" justify-content="space-between" align-items="center">
          <div class="text-body-3 text-white-2">Total spend</div>
          <div class="text-body-3 text-white-2">{{ supportData.year }}</div>
        </Grid>

        <div class="text-heading-1 text-white-2 text-right">
          {{ formatPrice(supportData.current_year_spend) }}
          {{ supportData.currency }}
        </div>
      </Grid>
    </template>
  </BaseChart>
</template>

<script>
import * as apiTo from '@/modular-api'
import { baseChartMixin } from '@/reusable/base-chart/base-chart-mixin'
import { chart, xAxis, yAxis } from '@/reusable/base-chart/chart-data'

const customChartData = {
  chart: chart(),
  xAxis: xAxis({ lineColor: '#9A9FAE' }, 'white'),
  yAxis: yAxis({}, 'white', undefined, '#9A9FAE'),
  plotOptions: {
    series: {
      color: 'white',
      marker: {
        radius: 6
      }
    }
  }
}

export default {
  mixins: [baseChartMixin],

  created() {
    this.getChartData()
    this.customChartData = customChartData
  },

  methods: {
    getChartData() {
      apiTo.GET_TOTAL_SPEND_CHART().then(({ data }) => {
        this.chartData = data.result.chart
        this.supportData = data.result.support_data
      })
    }
  }
}
</script>
